import { Component } from '@angular/core';

@Component({
  selector: 'ipm-data-table-mobile-view',
  templateUrl: './data-table-mobile-view.component.html',
  styleUrls: ['./data-table-mobile-view.component.scss']
})
export class DataTableMobileViewComponent {

}
